export default __webpack_public_path__ + "static/media/59_photo.7d70b278.jpg";